import { Backdrop, CircularProgress, Container, Grid } from "@material-ui/core";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import clsx from "clsx";
import MUIDataTable from "mui-datatables";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import Success from '../../../components/Form/Success';
import TextField from '../../../components/Form/TextField';
import ButtonUI from "../../../components/ui/ButtonUI";
import PageTitle from "../../../components/ui/PageTitleUI";
import { useAuth } from "../../../hooks/auth";
import { ShippingRequestInvoiceValidatePut, ShippingRequestSupplierPost, ShippingRequestSupplierSearch } from "../../../interfaces/ShippingRequest";
import InvoiceApi from "../../../services/InvoiceApi";
import ShippingRequestApi from "../../../services/ShippingRequestApi";
import getDefaultGridOptions from "../../../utils/componentUtils";
import utilsDate from "../../../utils/Date";
import { useStyles } from "./Style";
import { Alert } from "@mui/material";

const opcoes = [
    { url: '/ShippingRequest/Submit', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/ShippingRequest', descricao: 'Pesquisar', state: {}}
]

interface IFormInput {
    supplierId: number;
    supplierCorporateName: string;
    createdBy: string;
    createdAt: Date;
    supplier: any;
}

interface IPartNumbers{
    partNumberId?: number;
    partNumberCode: number;
    partNumberDescription: string;
    scheduledQuantity: number;
    shippingQuantity: number;
    invoiceQuantity: number;
}


const ShippingRequestValidateInvoice: React.FC = () => {
    const classes = useStyles();
    const [circularLoading, setCircularLoading] = React.useState(true);
    const [isInvoiceValid, setIsInvoiceValid] = React.useState(true);
    const [shippingRequest, setshippingRequest] = React.useState<any>();
    const { user } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation("ShippingRequest");
    const { t: _t } = useTranslation("General");
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const refFieldInvoiceKey = useRef<HTMLInputElement>()
    const refFieldInvoiceNumber = useRef<HTMLInputElement>()
    const refFieldObservation = useRef<HTMLInputElement>()
    const [partnumbers, setPartnumbers] = useState<any>() 
    const [success, setSuccess] = useState(false)
    const { control, handleSubmit, setValue } = useForm<any>({
        defaultValues: {
            protocol: "",
            supplier: "",
            scheduleDate: "",
            state: "",
            invoiceNumber: "",
            invoiceDate: ""
        },
    });

    const history = useHistory();

    const searchShippingRequestSuppliers = () => {

        let filter: ShippingRequestSupplierSearch = {
            companyId: +user.company.companyID,
            plantId: Number(user.company.plantID),
            pageSize: rowsPerPage,
            pageIndex: page,
            sort: "CreatedAt",
            sortDir: "desc",
        };

        ShippingRequestApi.searchSupplier(filter)
            .then((result) => {
                if (result && result.items) {
                    setPage(result.pageIndex);
                } else {
                    setPage(0);
                }
            })
            .catch(() => {
            });
    };

    useEffect(() => {
        var shippingRequestId = Number(window.location.pathname.toLowerCase().replace('/shippingrequest/validateinvoice/', ''))

        ShippingRequestApi.get(shippingRequestId).then((response) => {
            if (response) {
                setshippingRequest(response);
                setValue("protocol", response.protocolNumber);
                setValue("supplier", response.supplierId + " - " + response.supplierCorporateName);
                setValue("scheduleDate", utilsDate.DateShort(response.requestDate));
                setValue("state", response.statusDescription);
                setValue("invoiceKey", response.invoiceKey);
                setValue("invoiceNumber", response.invoiceNumber);
                setValue("invoiceDate", utilsDate.DateShort(response.invoiceDate));
                
                const resultado = response.partNumbers.map((item:any) => {
                    const encontrado = response.invoiceItems.find((x: any) => x.partNumberCode === item.partNumberCode);
                    return {
                        ...item,
                        invoiceQuantity: encontrado ? encontrado.quantity : 0 // ou algum valor padrão
                    };
                });

                const adicionais = response.invoiceItems
                .filter((x: any) => !resultado.some((item: any) => item.partNumberCode === x.partNumberCode))
                .map((x: any) => ({
                    partNumberCode: x.partNumberCode,
                    partNumberDescription: "",
                    scheduledQuantity: 0,
                    shippingQuantity: 0,
                    invoiceQuantity: x.quantity
                }));


                setPartnumbers([...resultado, ...adicionais]);
                if((response.invoiceKey ?? "") !== "" && response.invoiceKey.length === 44)
                    SearchInvoicePartNumbers();

                refFieldObservation.current!.value = response.invoiceProgrammerObservation;
                //setCircularLoading(false);
            } else {
                //setCircularLoading(false);
                // enqueueSnackbar(tGeneral("objectNotFound"), {
                //     variant: "warning",
                // });
            }
        }).finally(() => {
            setCircularLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, page, rowsPerPage]);

    const onSubmit = (data: any) => {
        handleSubmitPost(data);
    };

    const tableHeadAlignCenter = clsx({
        [classes.tableHeadCenter]: true,
    });

    const handleSubmitPost = (data: IFormInput) => {
        if(!data.supplier) {
            enqueueSnackbar(t("warningSelectSupplier"), {
                variant: "warning",
            });
            return;
        }

        
        
        let shippingRequestPost: ShippingRequestSupplierPost = {
            supplierId: data.supplier?.code,
            companyId: data.supplier?.companyId,
            supplierCorporateName: data.supplier?.name,
            plantId: Number(user.company.plantID),
        };

        
        ShippingRequestApi.postSupplier(shippingRequestPost)
            .then((result) => {
                enqueueSnackbar(t("returnSubmitFormSuccess"), {
                    variant: "success",
                });
            })
            .finally(() => {
                searchShippingRequestSuppliers();
            });
    };

    const columns = [
        {
            name: "id",
            options: {
                display: false,
            },
        },
        {
            name: "supplierId",
            options: {
                display: false,
            },
        },
        {
            name: "partNumberCode",
            label: t("partNumberCode"),
            options: {
                sort: true,
                setCellHeaderProps: () => ({
                    className: tableHeadAlignCenter,
                }),
                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: "partNumberDescription",
            label: t("partNumberDescription"),
            options: {
                sort: true,
                setCellHeaderProps: () => ({
                    className: tableHeadAlignCenter,
                }),
                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: "scheduledQuantity",
            label: t("scheduledQuantity"),
            options: {
                sort: true,
                setCellHeaderProps: () => ({
                    className: tableHeadAlignCenter,
                }),
                setCellProps: () => ({
                    align: "center",
                })
            },
        },
        {
            name: "shippingQuantity",
            label: t("shippingQuantity"),
            options: {
                sort: true,
                setCellHeaderProps: () => ({
                    className: tableHeadAlignCenter,
                }),
                setCellProps: () => ({
                    align: "center",
                })
            },
        },
        {
            name: "invoiceQuantity",
            label: t("invoiceQuantity"),
            options: {
                sort: true,
                setCellHeaderProps: () => ({
                    className: tableHeadAlignCenter,
                }),
                setCellProps:  (cellValue: any, rowIndex: number) => ({
                    align: "center",
                    style: {
                         
                         color: cellValue === 0 || partnumbers![rowIndex].shippingQuantity !== partnumbers![rowIndex].invoiceQuantity ? "Red" : "Black"
                    }
                })
            },
        },
        
    ];

    const SearchInvoicePartNumbers = async () : Promise<any> => {
        setCircularLoading(true);

        var invoiceKey = String(refFieldInvoiceKey.current!.value).trim();

        if(invoiceKey !== "" && invoiceKey.length < 44)
        {
            enqueueSnackbar(t("invalidInvoice"), { variant: "warning"});
            //refFieldInvoiceKey.current!.focus();
            setCircularLoading(false);
            return;
        }

        // Exibir na grid todos os Part numbers do shipping request...
        let partNumberList: IPartNumbers[] = shippingRequest.partNumbers.map((x:any) => { return {...x, invoiceQuantity: 0}; });

        await InvoiceApi.get(String(invoiceKey))
            .then((result) => {
                
                if(result === "" || result === null)
                    enqueueSnackbar(t("invoiceNotFound"), { variant: "warning" });
                else
                {
                    if (result.length > 0)
                    {
                        refFieldInvoiceNumber.current!.value = String(invoiceKey).substring(24,33);
                        setValue("invoiceDate", utilsDate.DateShort(result[0].issuanceDate));

                        //...depois, para cada item da NF, informar a qtd dela no item da grid. Caso nao encontre, incluir um novo item na lista, para exibir na tela:
                        result[0].invoicePartnumbers.map((invoicePN: any) => {
                            let pnItem = partNumberList.filter((shippingReqPN: any) => shippingReqPN.partNumberCode === invoicePN.partnumberCode);

                            //Nao encontrou esse item na lista do shipping request:
                            if (pnItem.length === 0)
                            {
                                pnItem = [{
                                    partNumberCode: invoicePN.partnumberCode,
                                    partNumberDescription: invoicePN.partNumberDescription,
                                    partNumberId: invoicePN.partnumberId,
                                    invoiceQuantity: invoicePN.comercialQuantity,
                                    scheduledQuantity: 0,
                                    shippingQuantity: 0
                                }];
                                partNumberList.push(pnItem[0]);
                            }
                            else
                                pnItem[0].invoiceQuantity = invoicePN.comercialQuantity;

                            return true;
                        });


                        setIsInvoiceValid(!partNumberList.some((x:any) => x.invoiceQuantity !== x.shippingQuantity));
                    }

                }
            })
            .finally(() => {
                setCircularLoading(false);
            
                //Exibir os PNs na grid:
                setPartnumbers(partNumberList);
            });
    }

    function Action(action: string)
    {
        let data: ShippingRequestInvoiceValidatePut = shippingRequest;

        data.invoiceProgrammerObservation = String(refFieldObservation.current!.value);
        data.invoiceNumber = String(refFieldInvoiceNumber.current!.value);
        data.invoiceKey = String(refFieldInvoiceKey.current!.value);

        setCircularLoading(true);
        if(action === "A")
        {
            ShippingRequestApi.approve(data) 
            .then((result) => {
                enqueueSnackbar(t("successApproved"), { variant: 'success' });
                setSuccess(true);
            })
            .finally(() => {
                setCircularLoading(false);
            });
        }
        else if(action === "D")
        {
            ShippingRequestApi.disapprove(data)
            .then((result) => {
                enqueueSnackbar(t("successDisapproved"), { variant: 'success' });
                setSuccess(true);
            })
            .finally(() => {
                setCircularLoading(false);
            });
        }
        else if(action === "C")
        {
            ShippingRequestApi.cancellation(shippingRequest.id, user.userName)
            .then((result) => {
                enqueueSnackbar(t("successCancel"), { variant: 'success' });
                setSuccess(true);
            })
            .finally(() => {
                setCircularLoading(false);
            });
        }
        else
        {
            history.replace('/ShippingRequest');
        }
        
       
    }


    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {},
            },
        },
    });

    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">
            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PageTitle title={t("titleValidateInvoice")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid
                            container
                            spacing={1}
                            style={{ marginBottom: 50 }}
                        >
                            <Grid container spacing={2} style={{paddingRight:20}}>
                                <Grid item xs={1} >
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true, classes: { input: classes.inputBlocked }}} label="Protocolo:" name="protocol" control={control} fullWidth />
                                </Grid>
                                <Grid item xs={3} >
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true, classes: { input: classes.inputBlocked }}} label="Fornecedor:" name="supplier" control={control} fullWidth />
                                </Grid>
                                <Grid item xs={1} >
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true, classes: { input: classes.inputBlocked }}} label="Data Programação:" name="scheduleDate" control={control} fullWidth />
                                </Grid>
                                <Grid item xs={2} >
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true, classes: { input: classes.inputBlocked }}} label="Estado:" name="state" control={control} fullWidth />
                                </Grid>
                                <Grid item xs={3} >
                                    <TextField InputLabelProps={{shrink:true}} 
                                        label={t("eInvoiceKey")} name="invoiceKey" 
                                        control={control} 
                                        fullWidth 
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') refFieldInvoiceKey.current?.blur();
                                        }}
                                        //onBlur={(e) => { if (e.target.value !== "") SearchInvoicePartNumbers(); } }
                                        inputRef={refFieldInvoiceKey}
                                    />
                                </Grid>
                                <Grid item xs={1} >
                                    <TextField InputLabelProps={{shrink:true}} 
                                        InputProps={{readOnly: true, classes: { input: classes.inputBlocked }}} 
                                        label={t("invoiceNumber")} 
                                        name="invoiceNumber" 
                                        control={control} fullWidth
                                        inputRef={refFieldInvoiceNumber} />
                                </Grid>
                                <Grid item xs={1} >
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true, classes: { input: classes.inputBlocked }}} label="Data da NF:" name="invoiceDate" control={control} fullWidth />
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>

                    {/* Aviso caso a Invoice informada nao sirva para ser utilizada */}
                    {!isInvoiceValid &&
                        (<Grid container spacing={1} style={{marginBottom: 10}}>
                            <Grid item xs={12}><Alert severity="error">{t('validation.invoiceRejectedReason')}</Alert></Grid>
                        </Grid>)}

                    <Grid style={{marginBottom:50}}>
                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable
                            title=""
                            data={
                                partnumbers
                            }                              
                            columns={columns}
                            options={{
                                ...getDefaultGridOptions(_t),
                                serverSide: false,
                                pagination: false,
                                sort: true,
                                selectToolbarPlacement: "none",
                                filter: false,
                                search: false,
                                download: false,
                                print: false,
                                viewColumns: false,
                                selectableRows: "none",
                            }}
                        />
                    </MuiThemeProvider>
                    </Grid>

                    <Grid container spacing={2} style={{marginBottom:50}}>
                                <Grid item xs={7} >
                                    <TextField multiline  
                                        maxRows={4} 
                                        InputLabelProps={{shrink:true}} 
                                        label={t("note")} 
                                        name="obs" 
                                        control={control} fullWidth 
                                        inputRef={refFieldObservation}/>
                                </Grid>
                    </Grid>
                    <Grid container>
                            <Grid item>
                                <ButtonUI
                                    color="primary"
                                    variant="contained"
                                    type="button"  
                                    onClick={() => Action("A")}
                                    disabled={!isInvoiceValid}
                                >
                                    Aprovar
                                </ButtonUI>
                            </Grid>
                            <Grid item>
                                <ButtonUI
                                    color="primary"
                                    variant="contained"
                                    type="button" 
                                    onClick={() => Action("D")}                                   
                                >
                                    Reprovar
                                </ButtonUI>
                            </Grid>
                            <Grid item>
                                <ButtonUI
                                    color="primary"
                                    variant="contained"
                                    type="button" 
                                    onClick={() => Action("C")}                                   
                                >
                                    Cancelar
                                </ButtonUI>
                            </Grid>
                            <Grid item>
                                <ButtonUI
                                    color="primary"
                                    variant="contained"
                                    type="button" 
                                    onClick={() => Action("")}                                 
                                >
                                    Voltar
                                </ButtonUI>
                            </Grid>
                    </Grid>
                </div>
            </div>
        </Container>
    );
};
export default ShippingRequestValidateInvoice;


